module.exports = __webpack_public_path__ + "media/images/countryrect/pf-5b49dc51a041e7952f63dd0cc894347d.svg";